module.exports = __webpack_public_path__ + "img/jewelryEncycImagListItem-1.52f64382.png";